module.exports = __webpack_public_path__ + "static/media/Dual_6851.2b93b89c.jpg";